import { Component, OnInit, Inject, ViewChildren, AfterViewInit, QueryList, ViewChild, ElementRef } from '@angular/core';
import { DialogButton, Dialog } from './dialog.interfaces';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { FocusMonitor } from '@angular/cdk/a11y';
import { CleanSubscriptions } from 'src/app/core/classes/clean-subcriptions';
import { Clipboard } from '@angular/cdk/clipboard';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'gio-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent extends CleanSubscriptions implements  AfterViewInit {

  @ViewChildren('actionButtons') actionButtons: QueryList<MatButton>;
  @ViewChild('mainContainer') mainContainer: ElementRef<HTMLElement>;

  currentFocusIndex = -1;
  buttons: {
    button: DialogButton;
    element: MatButton
  }[] = [];

  constructor(
    private _sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Dialog,
    private fMonitor: FocusMonitor,
    private clipboard: Clipboard,
    private util: UtilService
  ) { super(); }


  ngAfterViewInit() {

    const buttons = this.data.buttons;
    if (buttons.length > 0) {
      this.mapButtons();

      this.buttons.forEach(b => {
        if (b.button.default) {
          this.setElementFocus(b.element, 500);
        }
      })

    }
  }


  mapButtons() {
    const buttons = this.data.buttons;
    this.buttons = [];
    this.actionButtons.forEach((matButton, i) => {
      const btn = buttons[i];
      this.buttons.push({
        button: btn,
        element: matButton
      })
    });
  }

  setElementFocus(matButton: MatButton, delay = 10) {
    setTimeout(() => {
      const idx = this.buttons.findIndex(b => b.element == matButton);
      this.fMonitor.focusVia(matButton._elementRef.nativeElement, 'program');
      this.currentFocusIndex = idx;
    }, delay);
  }

  getMessageSinitized() {
    return this._sanitizer.bypassSecurityTrustHtml(this.data.message);
  }

  backdrop(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('dialog-container')) {
      // this.service.dismiss(true);
      this.dialogRef.close();
    }
  }

  handleButton(button: DialogButton) {
    if (button.handle) {
      this.dialogRef.close();
      button.handle(button);
    }
  }

  handleKeyUp(event: KeyboardEvent) {
    if (this.data.buttons && this.data.buttons.length > 0) {
      const button = this.data.buttons.find(b => {
        if (b.shortcut) {
          if (b.shortcut.ctrl && !event.ctrlKey) {
            return false;
          }

          if (b.shortcut.shift && !event.shiftKey) {
            return false;
          }

          if (b.shortcut.alt && !event.altKey) {
            return false;
          }

          return b.shortcut.key == event.key.toUpperCase();
        }
        return false;
      });

      if (button) {
        event.cancelBubble = true;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.handleButton(button);
        return;
      }

      if (event.key == 'ArrowLeft') {
        this.focusOnPrev();
      }
      if (event.key == 'ArrowRight') {
        this.focusOnNext();
      }

    }

  }

  getButtonsClass() {

    if (this.data.buttons.length == 1) {
      return 'justify-content-end';
    }
    return 'justify-content-around';
  }

  focusOnNext() {
    const button = this.buttons[this.currentFocusIndex + 1];
    if (button) {
      this.setElementFocus(button.element);
    }
  }

  focusOnPrev() {
    if (this.currentFocusIndex <= 0) {
      return
    }
    const button = this.buttons[this.currentFocusIndex - 1];
    if (button) {
      this.setElementFocus(button.element);
    }
  }

  copyToClipboard() {
    this.clipboard.copy(this.data.message);
    this.util.toast.info('Copiado para a área de transferência.');
  }

}
